namespace TabAurous.OMS {
    export namespace ProductSizeMasterAPIService {
        export const baseUrl = '~/api/Product/Sizes';

        export declare function Create(request: Serenity.SaveRequest<ProductSizeMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ProductSizeMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ProductSizeMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<ProductSizeMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "~/api/Product/Sizes/Create",
            Update = "~/api/Product/Sizes/Update",
            Delete = "~/api/Product/Sizes/Delete",
            Retrieve = "~/api/Product/Sizes/Retrieve",
            List = "~/api/Product/Sizes/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ProductSizeMasterAPIService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
